type ContractorListPropsType = {
  list: string[];
  currentTab: string;
};
const ContractorList = ({ list, currentTab }: ContractorListPropsType) => {
  return (
    <ul className="flex flex-col gap-8" data-testid={currentTab}>
      {list.map((item, i: number) => (
        <li key={`${item}${i}`} className="flex items-center justify-start ml-12">
          <span className="flex-shrink -mt-2 mr-10 icon-8 rounded-full bg-blue-dark" />
          <span>{item}</span>
        </li>
      ))}
    </ul>
  );
};

export default ContractorList;
